import React from 'react';
import Header from './Header';

const StudentLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="w-full">
        {children}
      </main>
    </div>
  );
};

export default StudentLayout;
